// @Vendors
import axios from 'axios'
import { BASE_API } from "constants/index"
import { getToken } from "utils/helpers"

export function getRolesServices(params = {}) {
	return axios.post(`${BASE_API}/roles`,  { params }, { headers:{
		"x-mppct-token": getToken()
	}})
}